import { render, staticRenderFns } from "./PurchaseField.vue?vue&type=template&id=342f6e6e&scoped=true"
import script from "./PurchaseField.vue?vue&type=script&lang=js"
export * from "./PurchaseField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f6e6e",
  null
  
)

export default component.exports